import { render, staticRenderFns } from "./index.vue?vue&type=template&id=41764146&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=41764146&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41764146')) {
      api.createRecord('41764146', component.options)
    } else {
      api.reload('41764146', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=41764146&lang=pug", function () {
      api.rerender('41764146', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hookPage/verifyMail/index.vue"
export default component.exports